__webpack_require__.p = "/mfe/pdp/_next/";